// envents
import events from '../authService/constants'
import event from '../authService/events'
import authService from '../authService'
import { getFirstLoginAccess } from '../authService/firstLoginAccess'
import { filterStatesByAccess, findFirstAllowedStateName, hasRoleAccess } from '../util/stateAccess'
// helpers
import get from 'lodash/get'
import { navigationCodeForState } from './navigation'
import { isPasswordRecoveryState } from '../authService/passwordRecoveryLink'
import { isCollaboratorInvitationState } from '../authService/collaboratorInvitationLink'


export default function config(router) {
  router.transitionService.onBefore({}, transition => {
    const options = get(transition?.options(), 'custom', {})
    const from = transition.exiting()
    const actualView = from[0]

    if (options?.ignoreOnBefore) return Promise.resolve()

    const targetState = transition.to()
    // Email-link flows are public, even when another account is already signed in.
    if (isPasswordRecoveryState(targetState.name) || isCollaboratorInvitationState(targetState.name)) return
    const user = authService.state.user || {}
    const { roles } = user
    const firstLogin = getFirstLoginAccess(user)
    if (user.isAuthenticated && user.profileLoaded && (!user.status || user.status === 'ACTIVE') && firstLogin.needsWizard && targetState.name !== 'firstLogin') {
      return transition.router.stateService.target('firstLogin')
    }
    // Init checks the server navigation before it mounts the destination UIView.
    const isAllowed = Boolean(navigationCodeForState(targetState.name)) || hasRoleAccess(targetState, roles)

    if (!isAllowed) {
      const registeredStates = filterStatesByAccess(router.stateRegistry.get(), roles)
      const fallbackStateName = findFirstAllowedStateName(registeredStates, roles) || 'App'

      return transition.router.stateService.target(fallbackStateName, {}, {
        custom: { ...options, ignoreOnBefore: true },
      })
    }


    if (actualView?.data?.generalOnBefore)
      return new Promise((resolve, reject) => {
        event.emit(events?.GENERAL_ON_BEFORE, {
          resolve,
          reject,
          msg: actualView?.data?.generalOnBefore
        })
      })
  })

  return router.urlRouter.otherwise('/')
}
